import { useEffect, useState } from 'react';
import Api from '../../../../../constants/Api';
import axiosInstance from '../../../../../services/AxiosInstance';
import LoadingCenter from '../../../Common/LoadingCenter';
import { useBranch } from '../../../../../context/BranchContext';
import { formatPhoneNumber, buildBirthdayWhatsappMessage, buildWhatsappUrl } from '../../../../../utils/FormatUtils';

const avatarColors = ['#d9e7f0', '#dcefe7', '#f8ead3', '#e7e0f4', '#f6dfe7', '#d9edf4'];
const textColors = ['#38556b', '#2e6a52', '#9a6419', '#5b4b86', '#8d4561', '#2f6e83'];

const getInitials = (name) => {
    if (!name) return '?';

    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length === 0) return '?';

    return parts.length >= 2
        ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
        : parts[0][0].toUpperCase();
};

const EmployeeBirthdayOfDay = ({ onCountChange }) => {
    const [rows, setRows] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const { selectedBranch } = useBranch();

    useEffect(() => {
        const branchId = selectedBranch ? selectedBranch.id : -1;
        setShowLoading(true);

        axiosInstance.get(`${Api.main.employee}/birthdays/${branchId}`)
            .then((response) => {
                const data = response.data || [];
                setRows(data);
                if (onCountChange) {
                    onCountChange(data.length);
                }
            })
            .finally(() => setShowLoading(false));
    }, [selectedBranch, onCountChange]);

    if (showLoading) return <LoadingCenter />;

    if (!rows.length) {
        return (
            <div className="birthday-list__empty">
                <i className="fa-solid fa-user-tie"></i>
                <p>Nenhum colaborador aniversariante hoje.</p>
            </div>
        );
    }

    return (
        <div className="birthday-list">
            {rows.map((row, index) => (
                <div key={row.id || row.phone || index} className="birthday-list__item">
                    <div
                        className="birthday-list__avatar"
                        style={{
                            background: avatarColors[index % avatarColors.length],
                            color: textColors[index % textColors.length]
                        }}
                    >
                        {getInitials(row.fullName)}
                    </div>

                    <div className="birthday-list__content">
                        <div className="birthday-list__name">{row.fullName}</div>
                        <div className="birthday-list__meta">
                            <span>
                                <i className="fa-solid fa-user-tie"></i>
                                Colaborador
                            </span>
                            {row.phone && (
                                <span>
                                    <i className="fa-solid fa-phone"></i>
                                    {formatPhoneNumber(row.phone)}
                                </span>
                            )}
                        </div>
                    </div>

                    {row.phone ? (
                        <a
                            href={buildWhatsappUrl(row.phone, buildBirthdayWhatsappMessage(row.fullName, 'employee'))}
                            target="_blank"
                            rel="noreferrer"
                            className="birthday-list__action"
                            title="Abrir mensagem de aniversário no WhatsApp"
                            aria-label={`Enviar mensagem de aniversário para ${row.fullName}`}
                        >
                            <i className="fa-brands fa-whatsapp fa-lg"></i>
                        </a>
                    ) : null}
                </div>
            ))}
        </div>
    );
};

export default EmployeeBirthdayOfDay;
